import { ScriptOutlineIcon } from './ScriptOutlineIcon';

/**
 * author: Austin Andrews
 * id 6E18A0EA-1F19-47E3-83DD-25732C1D318D
 * name script-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/script-outline.svg
 * tags
 * - Gaming / RPG 
 */
export const ScrollOutlineIcon = ScriptOutlineIcon;
export default ScrollOutlineIcon